import * as XLSX from "xlsx";

const formatOrderTags = (tags) =>
  (Array.isArray(tags) ? tags.filter(Boolean) : []).join(", ");

const dash = (value) => (value == null || value === "" ? "" : value);

const warehouseFulfillmentLabel = (warehouse) => {
  if (warehouse?.can_fulfill_order) {
    return "Can fulfill whole order";
  }
  if ((warehouse?.skus || []).some((sku) => sku.data_unavailable)) {
    return "Incomplete inventory data";
  }
  return "Cannot fulfill whole order";
};

export const buildExceptionsSheetRows = (report) => {
  const orders = report?.orders || [];
  const exceptions = orders.map((order) => ({
    "Order ID": order.order_id,
    "Order Date/Time": order.order_date_display,
    Status: order.status,
    Source: order.source || "",
    Tags: formatOrderTags(order.tags),
    Warehouse: order.warehouse || "",
    "SKU Count": order.sku_count,
    Units: order.units,
    "Inventory Status": order.inventory_status,
    "Age (days)": order.age_days,
  }));

  const skuDetails = [];
  orders.forEach((order) => {
    const networkTotals = order.warehouse_assigned === false;
    (order.skus || []).forEach((sku) => {
      skuDetails.push({
        "Order ID": order.order_id,
        Tags: formatOrderTags(order.tags),
        SKU: sku.sku,
        "Product/Item": sku.name || "",
        Ordered: dash(sku.ordered_quantity),
        "Total Inventory": dash(sku.quantity),
        "In Hand": dash(sku.in_hand),
        "In Transit": dash(sku.in_transit),
        "Immediate Shortfall": dash(sku.immediate_shortfall),
        "Remaining Shortfall": dash(sku.remaining_shortfall),
        "SKU Status": sku.sku_status,
        Warehouse: networkTotals ? "Across warehouses" : order.warehouse || "",
        "Warehouse fulfillment": "",
      });
    });
    (order.warehouse_breakdown || []).forEach((warehouse) => {
      (warehouse.skus || []).forEach((sku) => {
        skuDetails.push({
          "Order ID": order.order_id,
          Tags: formatOrderTags(order.tags),
          SKU: sku.sku,
          "Product/Item": sku.name || "",
          Ordered: dash(sku.ordered_quantity),
          "Total Inventory": dash(sku.quantity),
          "In Hand": dash(sku.in_hand),
          "In Transit": dash(sku.in_transit),
          "Immediate Shortfall": dash(sku.immediate_shortfall),
          "Remaining Shortfall": dash(sku.remaining_shortfall),
          "SKU Status": sku.sku_status,
          Warehouse: warehouse.warehouse_name,
          "Warehouse fulfillment": warehouseFulfillmentLabel(warehouse),
        });
      });
    });
  });

  return { exceptions, skuDetails };
};

export const downloadExceptionsXlsx = (
  report,
  fileName = "exceptions-report.xlsx",
) => {
  const { exceptions, skuDetails } = buildExceptionsSheetRows(report);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.json_to_sheet(exceptions),
    "Exceptions",
  );
  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.json_to_sheet(skuDetails),
    "SKU Details",
  );
  XLSX.writeFile(workbook, fileName);
};
